import { LanguageContext } from '../../../../context/LanguageContext';
import classes from './Title.module.css';

const Title = (props) => {
  const { data, maxWidth = null } = props;

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <div className={classes.titleWrapper} style={maxWidth ? { maxWidth } : undefined}>
            <span className={classes.nameText}>{data?.name[ctx.language]}</span>
            <span className={classes.authorText}>{data?.author[ctx.language]}</span>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default Title;
